module.exports = __webpack_public_path__ + "fonts/nunito-sans-light.3a318cfc.ttf";